var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M39.927 45.482a25.03 25.03 0 01-14.784 4.804C11.257 50.286 0 39.029 0 25.143 0 11.257 11.257 0 25.143 0c13.886 0 25.143 11.257 25.143 25.143a25.03 25.03 0 01-4.804 14.784l18.26 18.259a3.936 3.936 0 01.006 5.562 3.933 3.933 0 01-5.562-.006l-18.26-18.26zM25.143 42.43c9.546 0 17.286-7.74 17.286-17.286 0-9.547-7.74-17.286-17.286-17.286-9.547 0-17.286 7.74-17.286 17.286 0 9.546 7.74 17.286 17.286 17.286z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupe);
export default __webpack_public_path__ + "static/media/lupe.021c32fe07d5fd4d399f3092c5ec5587.svg";
export { ForwardRef as ReactComponent };